// Client-side mirror of backend/config/billingPlans.js (webpack cannot import ../backend).
// Stripe Price IDs: optional on the client. Backend uses STRIPE_* without REACT_APP_;
// add REACT_APP_STRIPE_* here only if the browser must read IDs (checkout still uses server env).
export const PLAN_LIMITS = {
  Basic: 300,
  Start: 10000,
  Business: 30000,
  Enterprise: 60000,
  Million: 100000,
  Unlimited: Infinity,
};

/**
 * Один источник правды для лимита, если с API нет значения или оно null.
 * @param {string} [planName] — имя плана (как в PLAN_LIMITS)
 * @param {number|typeof Infinity|undefined|null} planLimitFromApi
 */
export function resolvePlanLimit(planName, planLimitFromApi) {
  if (planLimitFromApi !== undefined && planLimitFromApi !== null) {
    return planLimitFromApi;
  }
  if (planName && Object.prototype.hasOwnProperty.call(PLAN_LIMITS, planName)) {
    return PLAN_LIMITS[planName];
  }
  return PLAN_LIMITS.Basic;
}

export const VALID_PAID_PLANS = [
  "Start",
  "Business",
  "Enterprise",
  "Million",
];

/** Имена планов в metadata Stripe-подписок: оплачиваемые + Unlimited (админ). */
export const VALID_STRIPE_SUBSCRIPTION_PLAN_NAMES = [
  ...VALID_PAID_PLANS,
  "Unlimited",
];

export const STRIPE_ONETIME_PRICE_IDS = {
  Start: process.env.REACT_APP_STRIPE_START_ONETIME_PRICE_ID,
  Business: process.env.REACT_APP_STRIPE_BUSINESS_ONETIME_PRICE_ID,
  Enterprise: process.env.REACT_APP_STRIPE_ENTERPRISE_ONETIME_PRICE_ID,
  Million: process.env.REACT_APP_STRIPE_MILLION_ONETIME_PRICE_ID,
};

export const STRIPE_SUBSCRIPTION_PRICE_IDS = {
  Start: process.env.REACT_APP_STRIPE_START_PRICE_ID,
  Business: process.env.REACT_APP_STRIPE_BUSINESS_PRICE_ID,
  Enterprise: process.env.REACT_APP_STRIPE_ENTERPRISE_PRICE_ID,
  Million: process.env.REACT_APP_STRIPE_MILLION_PRICE_ID,
};
